import { User } from './user';

export enum ProjectRole {
    CREATOR = 'creator',  // Project owner with full access
    ADMIN = 'admin',      // Admin with full access
    MEMBER = 'member',    // Can create and edit items
    VIEWER = 'viewer'     // Can only view items
}

// Helper function to check if a role has admin privileges
export const hasAdminPrivileges = (role: ProjectRole): boolean => {
    return role === ProjectRole.CREATOR || role === ProjectRole.ADMIN;
};

export enum ProjectAccessGroup {
    ALL = 'all',
    DOCUMENTS = 'documents',
    TASKS = 'tasks',
    CALENDAR = 'calendar'
}

export enum ProjectUserStatus {
    pending = 'pending',
    active = 'active',
    rejected = 'rejected'
}

export enum ProjectType {
    WEB = 'web',
    ANDROID = 'android',
    IOS = 'ios',
    MACOS = 'macos',
    WINDOWS = 'windows',
    LINUX = 'linux',
    DESKTOP = 'desktop',
    MOBILE = 'mobile',
    BACKEND = 'backend',
    API = 'api',
    EMBEDDED = 'embedded',
    GAME = 'game',
    OTHER = 'other'
}

export interface Project {
    id: number;
    name: string;
    description?: string;
    domain?: string;
    image_url?: string;
    prefix?: string;
    is_active?: boolean;
    created_by_id?: number;
    created_at: string;
    updated_at: string;
    project_type: ProjectType;
    
    // Relationships
    created_by?: User;
    role?: ProjectRole;
    users: ProjectUser[];
    userRole: ProjectRole;
    
    // Creator fields
    creator_first_name?: string;
    creator_last_name?: string;
    creator_email?: string;
}

export interface ProjectCreate {
    name: string;
    description: string;
    domain?: string;
    prefix?: string;
    image_url?: string;
    project_type: ProjectType;
}

export interface ProjectUpdate {
    name?: string;
    description?: string;
    domain?: string;
    prefix?: string;
    image_url?: string;
    is_active?: boolean;
    project_type?: ProjectType;
}

export interface ProjectUser {
    id: number;
    project_id: number;
    user_id: number;
    role: ProjectRole;
    status: ProjectUserStatus;
    access_groups: ProjectAccessGroup[];
    invited_by_id: number;
    created_at: string;
    updated_at: string;
    user_email: string;
    user_first_name: string;
    user_last_name: string;
    invited_by_email: string;
    joinedAt: string;
}

export interface ProjectUserInvite {
    email: string;
    role: ProjectRole;
    access_groups: ProjectAccessGroup[];
} 